import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Units from './Units';
import GridBlock from 'components/GridBlock';
import TextInput from "components/TextInput";
import Tr from "translations/Translations";
import getObjectValue from "libs/getObjectValue";
import clsx from 'clsx';
import INPUT_TYPE from "constants/INPUT_TYPE";
import WorkableIconEditButton from "components/button/WorkableIconEditButton";
import WorkableIconPreviewButton from "components/button/WorkableIconPreviewButton";
import Select from "components/Select";
import BooleanItems from "constants/BooleanItems";
import OfferSourceTypes from "constants/OfferSourceTypes";
import {ItemTypes} from "../../constants/itemTypes";
import WorkableIconAddButton from "components/button/WorkableIconAddButton";

const style = theme => ({
    root: {
        '&>*': {
            flexBasis: 0,

            '&:not(:first-child)': {
                marginLeft: theme.spacing(2),
            },
            '&:last-child': {
                marginLeft: theme.spacing(2),
            },
            '&:nth-child(1)': {
                flexGrow: 4
            },
            '&:nth-child(2)': {
                flexGrow: 3
            },
            '&:nth-child(3)': {
                flexGrow: 1
            },
            '&:nth-child(4)': {
                flexGrow: 1
            },
            '&:nth-child(5)': {
                flexGrow: 1
            },
            '&:nth-child(6)': {
                flexGrow: 1.6
            }
        }
    },
    rootWeight: {
        '&>*': {
            '&:nth-child(7)': {
                flexGrow: 1
            },
        }
    }
})

function SingleVariant(
    {
        classes,
        formikProps,
        id,
        handleEditItem,
        weightVisible,
        optionalItemsEnabled
    }) {

    const nameId = `${id}.0.name`;
    const typeId = `${id}.0.type`;
    const allowQuantityEditInOfferId = `${id}.0.allowQuantityEditInOffer`;
    const predefinedVatId = `${id}.0.offerVatPredefined`;
    const offerSourceTypeId = `${id}.0.offerSourceType`;
    const weightId = `${id}.0.weight`;
    const optionalItem = getObjectValue(`${id}.0.optionalItem`, formikProps.values, null);
    const editable = getObjectValue('_editable', formikProps.values, true);

    return (
        <GridBlock className={clsx(classes.root, {
            [classes.rootWeight]: weightVisible,
        })}>
            <TextInput
                id={nameId}
                label={Tr('name')}
                formikProps={formikProps}
                multiline
                disabled
            />
            <Units
                idPrefix={`${id}.0`}
                formikProps={formikProps}
                disabled
            />
            <Select
                label={Tr('position_type')}
                formikProps={formikProps}
                id={typeId}
                required
                disabled
                items={ItemTypes}
            />
            <Select
                label={Tr('offerVatPredefined_short')}
                formikProps={formikProps}
                id={predefinedVatId}
                required
                disabled
                items={BooleanItems}
            />
            <Select
                label={Tr('offerSourceType_short')}
                formikProps={formikProps}
                id={offerSourceTypeId}
                required
                disabled
                items={OfferSourceTypes}
                showErrorWithoutTouched
            />
            <Select
                label={Tr('allowQuantityEditInOffer_short')}
                formikProps={formikProps}
                id={allowQuantityEditInOfferId}
                required
                disabled
                items={BooleanItems}
            />
            {weightVisible && <TextInput
                id={weightId}
                type={INPUT_TYPE.NUMBER_19}
                step="0.01"
                label={Tr('weight')}
                endAdornment={'%'}
                formikProps={formikProps}
                required
                disabled
            />}
            {editable ?
                <WorkableIconEditButton
                    onClick={() => handleEditItem(0)}
                />
                :
                <WorkableIconPreviewButton
                    onClick={() => handleEditItem(0)}
                />
            }
            {optionalItemsEnabled && <WorkableIconAddButton
                tooltip={Tr('add_option')}
                onClick={() => handleEditItem(0, true)}
                disabled={!editable || !!optionalItem}
            />}
            <div/>
        </GridBlock>
    )
}

SingleVariant.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(SingleVariant);